import { render, staticRenderFns } from "./StockEntries.vue?vue&type=template&id=0b8230b3&scoped=true"
import script from "./StockEntries.vue?vue&type=script&lang=js"
export * from "./StockEntries.vue?vue&type=script&lang=js"
import style0 from "./StockEntries.vue?vue&type=style&index=0&id=0b8230b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8230b3",
  null
  
)

export default component.exports